import { IconType, SvgIcon } from './SvgIcon';

export const ErrorIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 80 80">
    <g filter="url(#filter0_f_5_18430)">
      <circle cx="40" cy="40" r="32" fill="#D13637" fillOpacity="0.15" />
    </g>
    <g clipPath="url(#clip0_5_18430)">
      <path
        d="M40.0004 59.5237C50.7831 59.5237 59.5242 50.7826 59.5242 39.9999C59.5242 29.2172 50.7831 20.4761 40.0004 20.4761C29.2177 20.4761 20.4766 29.2172 20.4766 39.9999C20.4766 50.7826 29.2177 59.5237 40.0004 59.5237Z"
        fill="#D13637"
      />
      <path
        d="M46 34L34 46"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34 34L46 46"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_5_18430"
        x="0"
        y="0"
        width="80"
        height="80"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="4" result="effect1_foregroundBlur_5_18430" />
      </filter>
      <clipPath id="clip0_5_18430">
        <rect width="40" height="40" fill="white" transform="translate(20 20)" />
      </clipPath>
    </defs>
  </SvgIcon>
);

ErrorIcon.displayName = 'ErrorIcon';
